import Vue from 'vue';

// @ts-ignore
export const setAll = (state, {all, campaignId}) => {
  Vue.set(state.all, campaignId, all.sort((a: any, b: any) => a.position - b.position));
};

// @ts-ignore
export const setOne = (state, one) => {
  state.one = one;
};

// @ts-ignore
export const setNewArticle = (state, newArticle) => {
  state.newArticle = newArticle;
};

